import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SiteMapLinkService {
	@Output() readonly logout: EventEmitter<any> = new EventEmitter();
	@Output() readonly notifications: EventEmitter<any> = new EventEmitter();
	openConfirmModal(): void {
		this.logout.emit();
	}

	showNotifications(): void {
		this.notifications.emit();
	}
}
